module.exports = __webpack_public_path__ + "static/media/identity-abstraack-flower-poster.b82b2f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-abstraack-flower-poster.png
// module id = 247
// module chunks = 0